import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import { saleChannelInitialValue } from 'components/organisms/forms/sales-channel/SalesChannelForm';
import { FormikHelpers } from 'formik';
import { useMutateOptions } from 'hooks';
import middleware from 'middleware';
import { useTranslation } from 'react-i18next';
import { PiX } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { usePostSalesChannel } from 'services/salesChannel';
import { usePostSalesChannelImage } from 'services/salesChannel/image';
import { ISaleChannelForm } from 'services/salesChannel/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { onErrorShowToast } from 'utils/service/errorHandler';
import { SaleChannelTabs } from 'components/organisms/forms/sales-channel/SalesChannelForm';

const CreateSaleChannel = () => {
 const { t } = useTranslation();
 const navigate = useNavigate();

 const createSaleChannel = usePostSalesChannel();
 const mutateOptions = useMutateOptions<ISaleChannelForm>();

 const addSaleChannelImage = usePostSalesChannelImage();

 const onGoToDetail = (id: string) => navigate(`/settings/sales-channel/${id}`);

 const onCreateSaleChannelImage = async (file: File, id: string) => {
  await addSaleChannelImage.mutateAsync(
   { file, id },
   {
    onError: (error) => onErrorShowToast(error, 'toast-message.add-file'),
    onSuccess: () => onGoToDetail(id),
   }
  );
 };

 const onCreateSale = async (
  values: ISaleChannelForm,
  helpers: FormikHelpers<ISaleChannelForm>
 ) => {
  await createSaleChannel.mutateAsync(
   middleware.saleChannel.formToQuery(values),
   {
    ...mutateOptions(helpers),
    onSuccess: ({ id }) =>
     values.file ? onCreateSaleChannelImage(values.file, id) : onGoToDetail(id),
   }
  );
 };

 return (
  <Form.SaleChannel
   i18nextPrefix="sales-channels"
   onSubmit={onCreateSale}
   backPath="/settings/sales-channels"
   tittle={t('saleChannel.create-sales')}
   initialValues={saleChannelInitialValue}
   disableTabs={[SaleChannelTabs.providers]}
   customBackItem={
    <Button
     type="button"
     onlyIcon
     onClick={() => navigate('/settings/sales-channel')}
    >
     <Button.Icon icon={<PiX />} />
    </Button>
   }
   topbarContent={
    <Button type="submit" variant={BUTTON_VARIANT.submit}>
     <Button.Text text={t('button.create')} />
    </Button>
   }
  />
 );
};

export default CreateSaleChannel;
